import { useMemo } from "react";
import { LeafletEngine } from "./engines/leaflet";
import { MapLegend } from "./legend";
import { DEFAULT_LEGEND, type MapEngineId, type MapEngineProps } from "./types";
import { fanOutCoincidentMarkers } from "./util";

interface MapProps extends MapEngineProps {
    engine?: MapEngineId;
    showLegend?: boolean;
}

/** Engine-agnostic map shell. Adding a new engine = drop a file under
 *  `./engines/<name>.tsx` exporting a component that takes
 *  `MapEngineProps` and add a branch here. The page never imports an
 *  engine directly.
 *
 *  Coincident-marker fan-out happens here so every engine sees already-
 *  spread markers — the engine itself stays dumb. */
export function Map({ engine = "leaflet", markers, legend = DEFAULT_LEGEND, showLegend = true, ...rest }: MapProps) {
    const fannedMarkers = useMemo(() => fanOutCoincidentMarkers(markers), [markers]);

    const engineEl = (() => {
        switch (engine) {
            case "leaflet":
            default:
                return <LeafletEngine markers={fannedMarkers} {...rest} />;
        }
    })();

    if (!showLegend) return engineEl;

    return (
        <div className="flex flex-col gap-3">
            {engineEl}
            <MapLegend entries={legend} />
        </div>
    );
}
